module.exports = __webpack_public_path__ + "img/StairNosing.1d1959b1.png";